export const fcmNames = {
	storageSpace: 'rgs-fcm-state',
	subscriptionState: 'FCM_SUB_STATUS',
};

export const fcmSubStatuses = {
	permission: 'granted',
	subscription: 'Success',
};
